import { render, staticRenderFns } from "./NewBlockButtonList.vue?vue&type=template&id=48e9cca0&scoped=true&lang=pug&"
import script from "./NewBlockButtonList.vue?vue&type=script&lang=js&"
export * from "./NewBlockButtonList.vue?vue&type=script&lang=js&"
import style0 from "./NewBlockButtonList.vue?vue&type=style&index=0&id=48e9cca0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e9cca0",
  null
  
)

export default component.exports